export default function WhyUs() {
  return (
    <section className="why-us">
      <div className="container">

        <div className="section-header">
          <h2>Why Choose R Vibes</h2>
          <p>Our commitment to quality and natural ingredients sets us apart</p>
        </div>

        <div className="features">

          <div className="feature">
            <div className="feature-icon">🌱</div>
            <div className="feature-content">
              <h3>Natural Ingredients</h3>
              <p>We use only the purest natural ingredients.</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon">🔬</div>
            <div className="feature-content">
              <h3>Scientific Formulation</h3>
              <p>Scientifically researched homeopathic blends.</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon">✅</div>
            <div className="feature-content">
              <h3>Quality Assured</h3>
              <p>Strict quality processes ensure excellence.</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon">🌍</div>
            <div className="feature-content">
              <h3>Holistic Wellness</h3>
              <p>Treating the whole person—not just symptoms.</p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
